import PropTypes from 'prop-types';

import {
    Group,
    Stack,
    Text,
} from '@mantine/core';
import {
    AccountApplication,
    AccountApplicationDimension,
} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {rbacActions} from "../../../../config/rbac/actions.ts";

const DimensionsTable = ({dimensions}: { dimensions: AccountApplicationDimension[] }) => {
    return (
        <>
            {dimensions.map((dimension, index) => (<Stack key={index} gap={'xs'}>
                <Group ml={'1em'} gap={'xs'}><Text
                    fw={600}>Name:</Text><Text>{dimension.name}</Text></Group>
                <Group ml={'1em'} gap={'xs'}><Text
                    fw={600}>Value:</Text><Text>{dimension.value}</Text></Group>
            </Stack>))}
        </>
    );
};

DimensionsTable.propTypes = {
    dimensions: PropTypes.array,
};

export const Profile = ({record}: { record: AccountApplication }) => {

    const properties = [
        {
            label: 'Name',
            value: record.application?.name as string,
            span: 3,
        }, {
            label: 'Current Status',
            value: record.accountApplicationStatus as string,
            span: 3,
        }, {
            label: 'Description',
            value: record.application?.description as string,
            span: 6,
        }, {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: rbacActions.UpdateAccountApplication,
            span: 3,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 3,
        }, {
            label: 'Managed By',
            value: typeof record.managedBy !== 'undefined' && record.managedBy !== null ? [record.managedBy.givenName, record.managedBy.familyName].join(' ') : 'n/a',
            rbac: rbacActions.UpdateAccountApplication,
            span: 3,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 3,
        }];


    return (
        <PlatformPropertyCard properties={properties}/>
    );


};

Profile.propTypes = {
    record: PropTypes.shape({
                                name: PropTypes.string,
                                description: PropTypes.string,
                                status: PropTypes.string,
                                createdBy: PropTypes.shape({
                                                               givenName: PropTypes.string,
                                                               familyName: PropTypes.string,
                                                           }),
                                managedBy: PropTypes.shape({
                                                               givenName: PropTypes.string,
                                                               familyName: PropTypes.string,
                                                           }),
                                created: PropTypes.string,
                                updated: PropTypes.string,
                            }),
};


